/**
 * FadeOverlayState enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file FadeOverlayState.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum FadeOverlayState {
  NONE = 0,
  FADING_IN = 1,
  FADING_OUT = 2,
  FADED_IN = 3,
  FADED_OUT = 4
}